import { InjectionToken } from '@angular/core';
import { AuthSession } from '../interfaces/auth-session.interface';

/**
 * No root factory: the implementation lives in the auth domain. Auth registers
 * it on the root injector — interceptors and guards resolve it before the
 * lazy auth route exists.
 */
export const AUTH_SESSION = new InjectionToken<AuthSession>('AuthSession');
